{
  "Empty": "Tuščias"
}
